import chat from './Chat';
import chatPopup from './ChatPopup';

export default { chat, chatPopup }
